<template>
  <div v-once class="APPOINTMENT-LIST-PLACEHOLDER">
    <span class="c-gray70 p-b-4  MESSAGE" selenium="agenda-empty-notice">
      You have no customer appointments to show. Reach out and schedule one today!
    </span>
    <img alt="appointments" src="./assets/emptystate_calendar.svg" />
  </div>
</template>

<script>
export default {
  name: 'appointment-list-placeholder',
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  .APPOINTMENT-LIST-PLACEHOLDER {
    @include padding(2 4 2, $md: 4 5 4);
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    align-items: center;
    text-align: left;
    background-color: white;
  }
  .MESSAGE {
    max-width: 375px;
  }
</style>
